import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useFetchRestaurantQuery } from '@/api/hooks/useRestaurant';

import { Typography } from '@/components/atoms/Typography';
import { TabPageLayout } from '@/components/templates/TabPageLayout';
import { TbAlertCircle } from 'react-icons/tb';
import { UpdateDigitalCertificateForm } from '@/components/organisms/UpdateDigitalCertificateForm';

export const CertificatePage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const restaurantId = id || '';

  const { data: restaurant } = useFetchRestaurantQuery({ id: restaurantId, withMenu: false }, { enabled: !!restaurantId });

  return (
    <TabPageLayout firstTitle={t('certificatePage.title')} secondTitle={restaurant?.name} restaurantId={restaurant?.id}>
      {!restaurant?.digitalCertificate && (
        <div className="flex gap-2 items-center bg-red-100 w-full rounded-xl p-5">
          <TbAlertCircle className="text-2xl text-[#E9001F]" />
          <div>
            <Typography variant="paragraph" weight="semibold" customColor="#E9001F">
              {t('swornDeclaration.certificateName')} <strong>{t('swornDeclaration.missing')}</strong>
            </Typography>
            <Typography variant="extraSmall" weight="regular" customColor="#E9001F">
              {t('swornDeclaration.pleaseUpdate')}
            </Typography>
          </div>
        </div>
      )}

      <section className="border border-gray-300 gap-5 p-4 md:p-10 rounded-xl">
        <Typography variant="h1" weight="semibold" marginClassName="mb-5">
          {restaurant?.digitalCertificate ? t('swornDeclaration.label.update') : t('swornDeclaration.label.write')}
        </Typography>

        {restaurant && <UpdateDigitalCertificateForm restaurant={restaurant} />}
      </section>
    </TabPageLayout>
  );
};
